export default "__VITE_ASSET__DOGoS3hD__"